import api from 'services/api'
import {UPLOAD_SOCIETY_STRUCTURE, GET_PROPERTIES_LIST, DELETE_PROPERTY} from '../endpoints'

export const uploadSocietyStructure = async (values) =>
  await api.post(UPLOAD_SOCIETY_STRUCTURE, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const getPropertiesList = async () => await api.post(GET_PROPERTIES_LIST)
export const deleteProperty = async (id) => await api.delete(DELETE_PROPERTY, {data: {id}})
